import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TableFooter,
  TablePagination,
  Box,
  Button,
  TableSortLabel,
  Checkbox,
} from "@mui/material";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import { Modal, Form } from "react-bootstrap";
import { useTheme } from "@mui/material/styles";
import { endPoints } from "../../constant/Environment";
import { addData, getAllFilterData } from "../../Utility/API";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import UserSearch from "./UserSearch";
import Loader from "../../components/Loader";
import Toaster from "../../components/Toast";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => onPageChange(event, 0);
  const handleBackButtonClick = (event) => onPageChange(event, page - 1);
  const handleNextButtonClick = (event) => onPageChange(event, page + 1);
  const handleLastPageButtonClick = (event) =>
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      {/* <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0}>
        {theme.direction === "rtl" ? <LastPage /> : <FirstPage />}
      </IconButton> */}
      <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      {/* <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        {theme.direction === "rtl" ? <FirstPage /> : <LastPage />}
      </IconButton> */}
    </Box>
  );
}

const OfferUser = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [offerName, setOfferName] = useState("");
  const [offerMsg, setOfferMsg] = useState("");
  const [creative, setCreative] = useState("");
  const [thumbimg, setThumbImg] = useState("");
  const [showthumbimg, setShowThumbImg] = useState("");
  const [showcreative, setShowCreative] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [offerCopy, setOfferCopy] = useState(null);
  const [termConditions, setTermConditions] = useState(null);
  const [totalcount, setTotalCount] = useState(1);
  

  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
    isCheckedFeatured: false,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCreative(file);
      setShowCreative(imageUrl);
      UploadImage(file);
    }
  };
  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const handleFileChangeThumb = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setThumbImg(file);
      setShowThumbImg(imageUrl);
      UploadImageThumb(file);
    }
  };
  const UploadImageThumb = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setThumbImg(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };
  const handleOk = () => {
    if (
      offerName &&
      // creative &&
      // thumbimg &&
      startDate &&
      startTime &&
      endDate &&
      endTime &&
      offerCopy &&
      termConditions 
  
    ) {
      let url =
        //  editData?.id
        //   ? `${endPoints.api.UPDATE_PROMO}`:
        `${endPoints.api.ADD_OFFER}`;

      const newStartDate = new Date(`${startDate}T${startTime}Z`).toISOString();
      const newEndDate = new Date(`${endDate}T${endTime}Z`).toISOString();

      let payload = {
        promo_name: offerName,
        promo_message:offerMsg,
        creative: creative,
        thumb_url: thumbimg,
        startdate: newStartDate,
        starttime: startDate,
        enddate: newEndDate,
        endtime: startDate,
        promo_copy: offerCopy,
        terms_condition: termConditions,
        menu_sort_order: '',
        isactive: checkboxes.isCheckedActive ? 1 : 0,
        isfeatured: checkboxes.isCheckedFeatured ? 1 : 0,
        userIds: selected,
       promoSite: "",
      };
      // if (editData?.id) {
      //   payload.id = editData.id;
      // }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            handleClose();
            setSelected([])
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };


  const filteredItems = {
    // name: "",
    // platform: "1",
    // status: "",
    // regdate: "",
    // state: "",
    // city: "",
    // accounNumber: "",
    acc_status: "",
    customerId: "",
    email: "",
    kyc_status: "",
    name: "",
    player_type: "",
    rg_limit: "",
    state: "",
    userName: "",
  };
  useEffect(() => {
    fetchUserData(1,filteredItems);
  }, []);

  const fetchUserData = async (page,data) => {
    setIsLoading(true);
    let url = `${endPoints.api.GET_USERS}/${page}/${rowsPerPage}`;
    try {
      const response = await getAllFilterData(url, data);
      if (response.status === "success") {
        setRows(response.data);
        setTotalCount(response.data[0]?.totalcount);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => row.idUser);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleCheckboxClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    fetchUserData(newPage + 1, filteredItems);
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    // setPage(0)
  };

  const handleViewUser = (id) => {
    navigate(`/user/${id}`);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const sortedRows = [...rows].sort((a, b) => {
    const isAsc = order === "asc";
    return (a[orderBy] < b[orderBy] ? -1 : 1) * (isAsc ? 1 : -1);
  });

  const create = () => {
    navigate("/CreateUser");
  };
  const searchList = (filterObj) => {
    fetchUserData(filterObj);
  };
  return (
    <>
      <div className="main">
        <Toaster />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Users</h2>
                </div>
              </div>
              <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                <div className="col-md-12">
                  <UserSearch addNew={create} searchList={searchList} />
                </div>
              </div>
              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <div
                      style={{
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={selected.length == 0 ? true : false}
                        onClick={() => {
                          setShow(true);
                         // alert("called");
                        }}
                      >
                        Create Offer
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          navigate("/offer-list");
                        }}
                      >
                        Offer List
                      </Button>
                    </div>

                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 750 }}
                        aria-label="User Table"
                        className="c_table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              Select
                              {/* <Checkbox
                                indeterminate={
                                  selected.length > 0 &&
                                  selected.length < rows.length
                                }
                                checked={
                                  rows.length > 0 && selected.length === rows.length
                                }
                                onChange={handleSelectAllClick}
                              /> */}
                            </TableCell>
                            {[
                              "Customer ID",
                              "User Name",
                              "First Name",
                              "Last Name",
                              "Email",
                              "Account Status",
                            ].map((header, index) => (
                              <TableCell
                                key={index}
                                align="center"
                                sortDirection={
                                  orderBy === header.toLowerCase()
                                    ? order
                                    : false
                                }
                              >
                                <TableSortLabel
                                  active={orderBy === header.toLowerCase()}
                                  direction={
                                    orderBy === header.toLowerCase()
                                      ? order
                                      : "asc"
                                  }
                                  onClick={() =>
                                    handleRequestSort(header.toLowerCase())
                                  }
                                >
                                  {header}
                                </TableSortLabel>
                              </TableCell>
                            ))}
                            {/* <TableCell align="center">Actions</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows
                            .map((row) => {
                              const isItemSelected = isSelected(row.idUser);
                              return (
                                <TableRow
                                  key={row.idUser}
                                  selected={isItemSelected}
                                >
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      checked={isItemSelected}
                                      onClick={(event) =>
                                        handleCheckboxClick(event, row.idUser)
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.idUser}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.login}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.name}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.surname}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.email}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.accountStatus}
                                  </TableCell>
                                  
                                </TableRow>
                              );
                            })}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                          <TablePagination
                            className="hide-rows-per-page-options"
                            rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                            colSpan={12}
                            count={
                              rowsPerPage === -1 ? rows.length : totalcount
                            }
                            rowsPerPage={rowsPerPage}
                            page={page - 1}
                            // count={rowsToDisplay.length}
                            // rowsPerPage={rowsPerPage}
                            // page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "rows per page",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <Modal
          show={show}
          onHide={handleClose}
          size="xl"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Manage Offer:</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-8">
                <Form.Group className="mb-3" controlId="providerName">
                  <Form.Label>Offer Name </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Offer Name"
                    value={offerName}
                    onChange={(event) => {
                      setOfferName(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-8">
                <Form.Group className="mb-3" controlId="providerName">
                  <Form.Label>Offer Message </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Offer Message"
                    value={offerMsg}
                    onChange={(event) => {
                      setOfferMsg(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="game">
                  <Form.Label>Upload Creative </Form.Label>
                  <div>
                  <Form.Label
                    className="text-danger"
                    style={{ fontSize: "12px", fontWeight: "800" }}
                  >
                    Normal image should be (350*350) <br />
                    For Featured Image (1100*350)
                  </Form.Label>
                  </div>
                
                  <Form.Control
                    type="file"
                    placeholder="Upload Creative"
                    onChange={handleFileChange}
                  />
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="startDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Start Date"
                    value={startDate}
                    onChange={(event) => {
                      setStartDate(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="startTime">
                  <Form.Label>Start Time</Form.Label>
                  <Form.Control
                    type="time"
                    placeholder="Start Time"
                    value={startTime}
                    onChange={(event) => {
                      setStartTime(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                {showcreative && (
                  <div>
                    <img
                      src={showcreative}
                      alt="Selected"
                      style={{ maxWidth: "100px" }}
                    />
                  </div>
                )}
              </div>

              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="endDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="End Date"
                    value={endDate}
                    onChange={(event) => {
                      setEndDate(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="endTime">
                  <Form.Label>End Time</Form.Label>
                  <Form.Control
                    type="time"
                    placeholder="End Time"
                    value={endTime}
                    onChange={(event) => {
                      setEndTime(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="game">
                  <Form.Label>Upload Thumb Image </Form.Label>

                  <Form.Control
                    type="file"
                    placeholder="Upload Creative"
                    onChange={handleFileChangeThumb}
                  />
                </Form.Group>
              </div>

              <div className="col-md-8">
                <Form.Group className="mb-3" controlId="promoCopy">
                  <Form.Label>Offer Copy :</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={offerCopy}
                    onChange={(event) => {
                      setOfferCopy(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-4">
                {showthumbimg && (
                  <div>
                    <img
                      src={showthumbimg}
                      alt="Selected"
                      style={{ maxWidth: "100px" }}
                    />
                  </div>
                )}
              </div>

              <div className="col-md-8">
                <Form.Group className="mb-3" controlId="termConditions">
                  <Form.Label>Terms and Conditions :</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={termConditions}
                    onChange={(event) => {
                      setTermConditions(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4"></div>

              <div className="col-md-4">
                <Form.Check
                  inline
                  label="Active"
                  name="isCheckedActive"
                  type={"checkbox"}
                  id={`inline-${"checkbox"}-1`}
                  onChange={handleCheckboxChange}
                  checked={checkboxes.isCheckedActive}
                />
                <Form.Check
                  inline
                  label="Featured"
                  name="isCheckedFeatured"
                  type={"checkbox"}
                  id={`inline-${"checkbox"}-2`}
                  onChange={handleCheckboxChange}
                  checked={checkboxes.isCheckedFeatured}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="contained" onClick={handleOk}>
              Apply
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </>
  );
};

export default OfferUser;
